import { z } from 'zod';
import { ChannelIdSchema } from './ids.js';
import { ImageUrlSchema } from './party.js';
import { SpotifyTrackIdSchema } from './spotify.js';
import { ArtistNamesSchema } from './track.js';
import { WrappedPartySchema } from './wrapped.js';
/**
 * One logged listen, in the order the room heard it. `dj` and `slotNumber` are
 * null for a play no stint covers — a DJ sampled after their slot closed —
 * rather than being credited to whoever happened to be nearest.
 */
export const PartyExportPlaySchema = z
    .strictObject({
    trackId: SpotifyTrackIdSchema.nullable(),
    name: z.string().min(1),
    artists: ArtistNamesSchema,
    album: z.string().min(1),
    artUrl: ImageUrlSchema,
    durationMs: z.number().int().nonnegative(),
    listenedMs: z.number().int().nonnegative(),
    startedAt: z.iso.datetime(),
    dj: z.string().min(1).nullable(),
    slotNumber: ChannelIdSchema.nullable(),
})
    .readonly();
/** Every play of the night, oldest first: the raw material for rebuilding it as a playlist. */
export const PartyExportSchema = z
    .strictObject({
    party: WrappedPartySchema,
    plays: z.array(PartyExportPlaySchema).readonly(),
})
    .readonly();
//# sourceMappingURL=export.js.map